<ng-container *ngIf="!!questionGroup && !!formGroup">
  <section [@fadeInOnEnter] [@slideInDownOnEnter] [@.disabled]="index === 0">
    <div class="form-question-group" [class.form-question-group--is-flat]="isFlat" [id]="'questionGroup' + index">
      <header role="banner" class="form-question-group__header" [class.form-question-group__header--is-flat]="isFlat">
        <h3 role="heading" *ngIf="!!questionGroup.questionNumber" class="form-question-group__header__number">
          Question&nbsp;{{ questionGroup.questionNumber }}
        </h3>

        <h4
          role="heading"
          *ngIf="questionGroup.title"
          class="form-question-group__header__title"
          [innerHTML]="title"
        ></h4>
        <p *ngIf="questionGroup.subtitle" class="form-question-group__header__subtitle" [innerHTML]="subtitle"></p>
        <p
          *ngIf="questionGroup.description"
          class="form-question-group__header__description"
          [class.form-question-group__header__description--is-flat]="isFlat"
          [innerHTML]="description"
        ></p>
      </header>

      <fieldset class="form-question-group__form" [formGroup]="formGroup">
        <ng-container *ngFor="let subGroup of questionGroup.subGroups; trackBy: trackBySubGroupIndex">
          <div
            class="form-question-group__subGroup"
            [class.form-question-group__subGroup--border]="subGroup.hasBorder"
            [class.form-question-group__subGroup--is-flat]="isFlat"
            [attr.selected]="subGroup?.borderSelectCondition && !!formGroup.value[subGroup.borderSelectCondition]"
          >
            <ng-container *ngFor="let question of subGroup.questions; trackBy: trackByQuestionType">
              <ng-container
                *ngIf="
                  !question?.displayCondition ||
                  (question?.displayCondition && question | displayCondition: formGroup.value)
                "
                [ngSwitch]="question.type"
              >
                <ng-container *ngSwitchCase="FormQuestionType.Checkbox">
                  <app-form-checkbox
                    [id]="question.formControlName + '-' + index"
                    [question]="question"
                    [formControlName]="question.formControlName"
                    (nextQuestion)="computeNext()"
                    (skipQuestion)="computeNext()"
                  ></app-form-checkbox>
                </ng-container>
                <ng-container *ngSwitchCase="FormQuestionType.City">
                  <app-form-location-picker
                    [class.form-question-group__subGroup__item]="!subGroup.hasBorder"
                    [class.form-question-group__subGroup__border-item]="subGroup.hasBorder"
                    [id]="question.formControlName + '-' + index"
                    [question]="question"
                    [formControlName]="question.formControlName"
                    (nextQuestion)="computeNext()"
                    (skipQuestion)="computeNext()"
                  ></app-form-location-picker>
                </ng-container>
                <ng-container *ngSwitchCase="FormQuestionType.Dropdown">
                  <app-form-dropdown
                    [class.form-question-group__subGroup__item]="!subGroup.hasBorder"
                    [class.form-question-group__subGroup__border-item]="subGroup.hasBorder"
                    [id]="question.formControlName + '-' + index"
                    [question]="question"
                    [formControlName]="question.formControlName"
                    (nextQuestion)="computeNext()"
                    (skipQuestion)="computeNext()"
                  ></app-form-dropdown>
                </ng-container>
                <ng-container *ngSwitchCase="FormQuestionType.File">
                  <app-form-file
                    [class.form-question-group__subGroup__item]="!subGroup.hasBorder"
                    [class.form-question-group__subGroup__border-item]="subGroup.hasBorder"
                    [id]="question.formControlName + '-' + index"
                    [question]="question"
                    [formControlName]="question.formControlName"
                    (nextQuestion)="computeNext()"
                    (skipQuestion)="computeNext()"
                  ></app-form-file>
                </ng-container>
                <ng-container *ngSwitchCase="FormQuestionType.Number">
                  <app-form-number
                    [class.form-question-group__subGroup__item]="!subGroup.hasBorder"
                    [class.form-question-group__subGroup__border-item]="subGroup.hasBorder"
                    [id]="question.formControlName + '-' + index"
                    [question]="question"
                    [formControlName]="question.formControlName"
                    (nextQuestion)="computeNext()"
                    (skipQuestion)="computeNext()"
                  ></app-form-number>
                </ng-container>
                <ng-container *ngSwitchCase="FormQuestionType.Textarea">
                  <app-form-textarea
                    [class.form-question-group__subGroup__item]="!subGroup.hasBorder"
                    [class.form-question-group__subGroup__border-item]="subGroup.hasBorder"
                    [id]="question.formControlName + '-' + index"
                    [question]="question"
                    [formControlName]="question.formControlName"
                    (nextQuestion)="computeNext()"
                    (skipQuestion)="computeNext()"
                  ></app-form-textarea>
                </ng-container>
                <ng-container *ngSwitchCase="FormQuestionType.YesNo">
                  <app-form-yes-no
                    [class.form-question-group__subGroup__item]="!subGroup.hasBorder"
                    [class.form-question-group__subGroup__item--is-flat]="isFlat"
                    [class.form-question-group__subGroup__border-item]="subGroup.hasBorder"
                    [id]="question.formControlName + '-' + index"
                    [question]="question"
                    [formControlName]="question.formControlName"
                    [isFlat]="isFlat"
                    (nextQuestion)="computeNext()"
                    (skipQuestion)="computeNext()"
                  ></app-form-yes-no>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <app-form-text
                    [btnLabel]="question?.btnLabel"
                    [class.form-question-group__subGroup__item]="!subGroup.hasBorder"
                    [class.form-question-group__subGroup__border-item]="subGroup.hasBorder"
                    [id]="question.formControlName + '-' + index"
                    [question]="question"
                    [formControlName]="question.formControlName"
                    (nextQuestion)="computeNext()"
                    (skipQuestion)="computeNext()"
                  ></app-form-text>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </fieldset>

      <footer class="form-question-group__actions" *ngIf="questionGroup?.displayValidate as validateMessages">
        <button
          class="btn"
          type="button"
          (click)="computeNext()"
          [attr.aria-label]="'Valider la question: ' + questionGroup.ariaLabel"
          *ngIf="validateMessages?.btnText"
        >
          {{ validateMessages.btnText }}
        </button>

        <span
          class="form-question-group__actions__error"
          [class.form-question-group__actions__error--is-flat]="isFlat"
          *ngIf="(questionGroupError$ | async) === true && validateMessages?.errorText"
        >
          {{ questionGroup.displayValidate.errorText }}
        </span>
      </footer>
    </div>
  </section>
</ng-container>
